export enum ActionType {
  POP_UP_OPEN = 'POP_UP_OPEN',
  POP_UP_CLOSE = 'POP_UP_CLOSE',
  SET_POP_UP_HEADER = 'SET_POP_UP_HEADER',
  SET_POP_UP_CONTENT = 'SET_POP_UP_CONTENT',
  SET_POP_UP_FOOTER = 'SET_POP_UP_FOOTER',
  SET_DOCTOR_APPOINTMENT = 'SET_DOCTOR_APPOINTMENT',
  SET_VYDURA_REMINDER = 'SET_VYDURA_REMINDER',
  SET_VYDURA_SCHEDULE = 'SET_VYDURA_SCHEDULE',
  SET_MIGRAINE_ATTACK = 'SET_MIGRAINE_ATTACK',
}
